/* */ 
'use strict';
var Schema = require('../schema');
module.exports = new Schema({explicit: [require('../type/str'), require('../type/seq'), require('../type/map')]});
